const DataTypes = {
  TEXT: 'text',
  BOMVALUES: 'bomValues',
  MODELVALUES: 'modelValues',
  PROCESSDATA: 'processData',
};

DataTypes.options = [DataTypes.TEXT, DataTypes.BOMVALUES, DataTypes.MODELVALUES, DataTypes.PROCESSDATA];

const ModelValues = {
  NAME: 'modelName',
  CODE: 'modelCode',
};

ModelValues.options = [ModelValues.NAME, ModelValues.CODE];

const BOMValues = {
  BOMVARIABLE: 'bomVariable',
  NAME: 'optionName',
  VALUE: 'optionValue',
};

BOMValues.options = [BOMValues.NAME, BOMValues.VALUE];

export { DataTypes, ModelValues, BOMValues };
export default DataTypes;


